export function createDataCatalogLineageClient(transport) {
    return {
        /**
         * List every tenant's catalogued datasets, with their lineage in the row
         *
         * Requires scope: data-catalog:platform:read
         */
        listPlatformCatalogDatasets(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/catalog/datasets",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/catalog/datasets/{datasetId}/versions
         *
         * Requires scope: data-catalog:publish
         */
        publishDatasetVersion(tenantId, datasetId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/catalog/datasets/${encodeURIComponent(datasetId)}/versions`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/catalog/datasets/{datasetId}
         *
         * Requires scope: data-catalog:read
         */
        getCurrentDatasetVersion(tenantId, datasetId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/catalog/datasets/${encodeURIComponent(datasetId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/catalog/lineage-edges
         *
         * Requires scope: data-lineage:write
         */
        recordLineageEdge(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/catalog/lineage-edges`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/catalog/datasets/{datasetId}/lineage
         *
         * Requires scope: data-lineage:read
         */
        listDatasetLineage(tenantId, datasetId, direction, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/catalog/datasets/${encodeURIComponent(datasetId)}/lineage`,
                query: { direction: direction },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=data-catalog-lineage.js.map